import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';

export const LAVyer = initConst<IComponentsConfig>(() => ({}));
